import { ICard } from "../../../../pages/dashboard/models/DashboardModels";
import HighlightCard from "../../../organisms/Cards/HighlightCard/HighlightCard";
import { Row } from "react-bootstrap";

interface Props {
  cardsData: ICard[];
}
const Highlights = (props: Props) => {
  const { cardsData } = props;
  return (
    <Row className="highlights-container">
      {cardsData.map((card, index) => (
        <HighlightCard
          key={index}
          index={index}
          title={card.title}
          count={card.count}
          className={card.className}
          icon={card.icon}
          width={card.width}
          height={card.height}
          url={card.link}
          subTitle={card.subTitle}
        />
      ))}
    </Row>
  );
};

export default Highlights;
